import React from 'react';
import { useLocation } from 'react-router-dom';

export const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};

/**
 * Return query params as JSON object
 *
 * @export
 * @template T
 * @return {*}  {T}
 */
export function useQueryParams<T = { [key: string]: any }>(): T {
  const { search } = useLocation();

  return React.useMemo(() => {
    const params: any = {};

    new URLSearchParams(search).forEach((value, key) => {
      params[key] = value;
    });

    return params as T;
  }, [search]);
}

